import type { SessionResponse } from "@frontier/protocol/contracts";
import type { PlatformAuthAdapter } from "./platform-session";
import { api } from "./session-api";
import { initializeVkPlaySdk } from "./vkplay-sdk";
import type { VkPlaySdk } from "./vkplay-sdk";

export class VkPlayAuthAdapter implements PlatformAuthAdapter {
  readonly provider = "vkplay";
  readonly hasLaunchProof: boolean;
  readonly messages = {
    missingProof: "Перезапусти игру через VK Play, чтобы подтвердить вход.",
    foreignSession: "Открой игру через VK Play, чтобы подтвердить пилота.",
    unconfirmedIdentity: "VK Play не подтвердил пилота. Повторите подключение.",
  };

  constructor(
    private readonly appId: string,
    private readonly launchParams: string,
    private readonly requests: Pick<typeof api, "vkPlaySession"> = api,
    private readonly initializeSdk: (
      appId: string,
    ) => Promise<VkPlaySdk> = initializeVkPlaySdk,
  ) {
    this.hasLaunchProof = launchParams.length > 0;
  }

  async initialize(): Promise<void> {
    const sdk = await this.initializeSdk(this.appId);
    const status = await sdk.loginStatus();
    if (status < 2)
      throw new Error(
        status === 0
          ? "Войди через VK Play, чтобы открыть своего пилота."
          : "Подключи игру к аккаунту VK Play, чтобы продолжить.",
      );
  }

  exchange(guestToken?: string): Promise<SessionResponse> {
    return this.requests.vkPlaySession(this.launchParams, guestToken);
  }

  async continueLogin(): Promise<void> {
    const sdk = await this.initializeSdk(this.appId);
    await sdk.loginStatus();
    sdk.continueLogin();
  }
}
